/**
 * People, places and tags are written into the sentence, not collected by
 * separate pickers beside it. "@ana at @bar-neu #bouldering" is how anyone
 * would type it anyway, so the text is the only input.
 */
import { cleanInterest, MAX_INTERESTS } from './interests.js';

// A handle is what the account rules already allow: a-z, 0-9, underscore.
export const MENTION_RE = /(^|[^\w@])@([a-z0-9_]{2,20})/gi;
export const TAG_RE = /(^|[^\w#])#([\p{L}\p{N}][\p{L}\p{N}_-]{0,29})/giu;

export function mentionAtCaret(value, caret) {
  if (!Number.isInteger(caret)) return null;
  const match = String(value).slice(0, caret).match(/(^|[^\w@])@([a-z0-9_]*)$/i);
  if (!match) return null;
  return { start: caret - match[2].length - 1, end: caret, query: match[2].toLowerCase() };
}

export function matchingFriends(friends, mention, limit = 6) {
  if (!mention) return [];
  return (Array.isArray(friends) ? friends : []).filter((friend) => friend.username && (
    !mention.query
    || friend.username.toLowerCase().startsWith(mention.query)
    || friend.displayName?.toLowerCase().includes(mention.query)
  )).slice(0, limit);
}

export function insertMention(value, mention, username, maxLength = 200) {
  const suffix = value.slice(mention.end);
  const replacement = `@${username}${/^\s/.test(suffix) ? '' : ' '}`;
  const text = `${value.slice(0, mention.start)}${replacement}${suffix}`
    .slice(0, maxLength);
  return { text, caret: Math.min(mention.start + replacement.length, text.length) };
}

/** Handles named in a body, lowercased and deduped, in the order written. */
export function mentionsIn(text) {
  const found = [];
  for (const [, , handle] of String(text ?? '').matchAll(MENTION_RE)) {
    const lower = handle.toLowerCase();
    if (!found.includes(lower)) found.push(lower);
  }
  return found;
}

/**
 * Tags named in a body. Run through the same normaliser as profile interests,
 * so "#Cycling" and the interest "cycling" are the same thing and the panel's
 * shared-interest sort keeps working.
 */
export function tagsIn(text) {
  const found = [];
  for (const [, , tag] of String(text ?? '').matchAll(TAG_RE)) {
    const clean = cleanInterest(tag);
    if (clean && !found.includes(clean)) found.push(clean);
    if (found.length === MAX_INTERESTS) break;
  }
  return found;
}
